// NOTE: QUERY KEYS
export const YOUTUBE_LIST_QUERY_KEY = "youtubeList";
export const CAMPAIGN_LIST_QUERY_KEY = "campaignList";
export const CAMPAIGN_DETAIL_QUERY_KEY = "campaignDetail";
export const MEMBER_DETAIL_QUERY_KEY = "memberDetail";
export const ACTIVITY_LIST_QUERY_KEY = "activityList";
export const ACTIVITY_DETAIL_QUERY_KEY = "activityDetail";
export const HISTORY_LIST_QUERY_KEY = "historyList";
export const CALENDAR_LIST_QUERY_KEY = "environmentEvents";
export const MEDIA_LIST_QUERY_KEY = "mediaList";
export const MEMBER_LIST_QUERY_KEY = "memberList";
export const ACCOUNT_REPORT_LIST_QUERY_KEY = "accountReport";
export const EXECUTIVE_LIST_QUERY_KEY = "executiveList";
export const HOME_BANNER_QUERY_KEY = "homeBanner";

export const USER_DATA_QUERY_KEY = "userData";

// NOTE: LOAD SIZES
export const LOAD_SIZE_4 = 4;
